export default Object.freeze({
  info: {},
  reportLinks: {},
});
